import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    loadingProjects: true,
    projects: [],
  },
  getters,
  mutations,
  actions
}
